export default "__VITE_ASSET__DrZvCitO__"